var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShiftLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "12px",
    viewBox: "0 0 7 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "About",
    transform: "translate(-1241.000000, -3387.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 2572.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1242.7071,815.292886 C1242.31659,814.902371 1241.6834,814.902371 1241.29289,815.292886 C1240.90237,815.683401 1240.90237,816.316587 1241.29289,816.707102 L1245.58579,821 L1241.29289,825.292898 C1240.90237,825.683413 1240.90237,826.316599 1241.29289,826.707114 C1241.6834,827.097629 1242.31659,827.097629 1242.7071,826.707114 L1247.70711,821.707108 C1248.09763,821.316593 1248.09763,820.683407 1247.70711,820.292892 L1242.7071,815.292886 Z",
    id: "Path-Copy",
    transform: "translate(1244.500000, 821.000000) scale(-1, 1) translate(-1244.500000, -821.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiftLeftArrow);
export default __webpack_public_path__ + "static/media/shift-left-arrow.bbfc5e080e10b6c775bbc8a592497ae2.svg";
export { ForwardRef as ReactComponent };